export enum ESystemUserPermission {
  DashboardEdit = 'dashboard_edit',
  PackagesEdit = 'packages_edit',
  PackagesView = 'packages_view',
  CustomersEdit = 'customers_edit',
  CustomersView = 'customers_view',
  SystemUsersEdit = 'system_users_edit',
  SystemUsersView = 'system_users_view',
  PromoCampaignsEdit = 'promocampaigns_edit',
  PromoCampaignsView = 'promocampaigns_view',
  CarrierStatusEdit = 'carrier_status_edit',
  CarrierStatusView = 'carrier_status_view',
  NotificationsEdit = 'notifications_edit',
  NotificationsView = 'notifications_view',
  AppSettingsView = 'app_settings_view',
  AppSettingsEdit = 'app_settings_edit',
  PromocodesView = 'promocodes_view',
  PromocodesEdit = 'promocodes_edit',
  // TODO: uncomment in MVP 2
  // CalculatorEdit = 'calculator_edit',
  // CalculatorView = 'calculator_view',
}
